var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener, FocusEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class DynamicFieldsAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
        /** @event */
        this.onBlur = new FocusEventListener();
        /** @event */
        this.onFocus = new FocusEventListener();
    }
    /**
     * Obtains the data used to generate the fields
     */
    getData() {
        return this.state.data;
    }
    /**
     * Updates the data used to generate the fields
     *
     * @param data - the data used to generate the fields
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Obtains the metadata used to generate the fields
     */
    getMetadata() {
        return this.state.metaData;
    }
    /**
     * Updates the metadata used to generate the fields
     *
     * @param metaData - the metadata used to generate the fields
     */
    setMetadata(metaData) {
        this.setState({ metaData });
    }
    /**
     * This method is here only to comply with Changeable class types.
     */
    //@ts-ignore - avoid error by overriding this method
    getValue() {
        return;
    }
    /**
     * This method is here only to comply with Changeable class types.
     */
    setValue() {
        return;
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DynamicFieldsAPI.prototype, "onChange", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DynamicFieldsAPI.prototype, "onBlur", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DynamicFieldsAPI.prototype, "onFocus", void 0);
export { DynamicFieldsAPI, };
//# sourceMappingURL=dynamic-fields-api.js.map